import { PropsWithChildren, useCallback, useState } from 'react';

import { useForm } from 'react-hook-form';

import { useTranslate } from '@i18n';
import { Button, Input, ModalBase, ModalBody, ModalFooter, ModalHeader, u } from '@ui';

type NameModalProps = PropsWithChildren<{
    header: string;
    value: string;
    label: string;
    onDismiss: () => void;
    onSubmit: (name: string) => void;
}>;

export const NameModal = ({ header, value, label, onDismiss, onSubmit, children }: NameModalProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const { register, getValues } = useForm({
        defaultValues: { name: value },
    });
    const handleSubmit = useCallback(() => {
        setIsLoading(true);
        const name = getValues('name');
        onSubmit(name);
    }, [getValues, onSubmit]);

    const t = useTranslate();

    return (
        <ModalBase open onDismiss={onDismiss} variant="partial">
            <ModalHeader>{header}</ModalHeader>
            <ModalBody pb={u(4)}>
                <Input {...register('name')} label={label} />
                {children}
            </ModalBody>
            <ModalFooter
                primary={
                    <Button onClick={handleSubmit} isLoading={isLoading}>
                        {t('generic_ui.save_as')}
                    </Button>
                }
                secondary={
                    <Button variant="secondary" onClick={onDismiss}>
                        {t('generic_ui.cancel')}
                    </Button>
                }
            ></ModalFooter>
        </ModalBase>
    );
};
